import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { AddIcon } from "../../../../data/iconImage";
import { formatDate } from "../../../../commons/FormatValue";
import { filteredItemBySearch } from "../../../../utils/ManageArray";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import CustContractItemsService from "../../../../services/custcontractitem.service";
import DefineAgeEquipsService from "../../../../services/defineageequips.service";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function DetermineAgeTab() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState({
    Contract: [],
    Age: [],
    Sticker: []
  });
  const [data, setData] = useState({ Contract: [], Age: [] });
  const defaultSearch = {
    Contract: [
      {
        name: "Contract_No",
        label: "เลขที่สัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest:
              CustContractItemsService.getAllCustContractItems(query),
            callback: ({ items }) =>
              setData((prev) => ({ ...prev, Contract: items }))
          })
      },
      {
        name: "Contract_Type",
        label: "สถานะสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true,
        findValue: { value: "Contract_No" }
      },
      {
        name: "CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        disabled: true,
        findValue: { value: "Contract_No" }
      },
      {
        name: "CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        disabled: true,
        findValue: { value: "Contract_No" }
      },
      {
        name: "CustContract.Project_No",
        label: "เลขที่โครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true,
        findValue: { value: "Contract_No" }
      },
      {
        name: "CustContract.Customer.Cus_Code",
        label: "รหัสลูกค้า/สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true,
        findValue: { value: "Contract_No" }
      },
      {
        name: "CustContract.Customer.Cus_Name",
        label: "ซื่อลูกค้า/สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        disabled: true,
        findValue: { value: "Contract_No" },
        size: 6
      }
    ],
    Age: [
      {
        name: "Item.Item_Code",
        label: "รหัสสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        noneAsync: true
      },
      {
        name: "Item.Item_Name_TH",
        label: "ชื่อสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9,
        noneAsync: true
      }
    ],
    Sticker: [
      {
        name: "Item.Item_Code",
        label: "รหัสสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        noneAsync: true
      },
      {
        name: "Item.Item_Name_TH",
        label: "ชื่อสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9,
        noneAsync: true
      }
    ]
  };
  const [searchInput, setSearchInput] = useState(defaultSearch);
  const columns = {
    Contract: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสสินค้า",
        selector: (row) => row.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "รายละเอียดสินค้า",
        selector: (row) => row.Item?.Item_Name_TH,
        minWidth: "300px"
      },
      {
        name: "ประเภทบริการ",
        selector: (row) => row.DownTime?.DT_Name,
        minWidth: "150px"
      },
      {
        name: "จำนวน PM/ปี",
        selector: (row) => row.PM_Per_Year,
        minWidth: "150px"
      }
    ],
    Age: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "รายละเอียดอุปกรณ์/อะไหล่",
        selector: (row) => row.ChildBom?.Item?.Item_Name_TH,
        minWidth: "300px"
      },
      {
        name: "Model Number",
        selector: (row) => row.ChildBom?.Item?.Item_Model,
        minWidth: "150px"
      },
      {
        name: "จำนวน",
        selector: (row) => row.ChildBom?.Item_Child_Qty,
        minWidth: "150px"
      },
      {
        name: "หน่วย",
        selector: (row) => row.ChildBom?.Item?.Unit,
        minWidth: "150px"
      },
      {
        name: "อายุใช้งาน (เดือน)",
        selector: (row) => row.Item_Age,
        minWidth: "150px"
      },
      {
        name: "วันที่เริ่มต้น",
        selector: (row) => row.Age_Start_Date,
        format: (row) => formatDate(row.Age_Start_Date),
        minWidth: "200px"
      },
      {
        name: "วันที่หมดอายุ",
        selector: (row) => row.Age_End_Date,
        format: (row) => formatDate(row.Age_End_Date),
        minWidth: "200px"
      },
      { name: "หมายเหตุ", selector: (row) => row.Remark, minWidth: "200px" },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            editButton
            state={{
              edit: { name: "determine", type: "age", row, searchValue }
            }}
          />
        ),
        width: "120px"
      }
    ],
    Sticker: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row.ChildBom?.Item?.Item_Code,
        minWidth: "200px"
      },
      {
        name: "รายละเอียดอุปกรณ์/อะไหล่",
        selector: (row) => row.ChildBom?.Item?.Item_Name_TH,
        minWidth: "300px"
      },
      {
        name: "Model Number",
        selector: (row) => row.ChildBom?.Item?.Item_Model,
        minWidth: "150px"
      },
      {
        name: "อายุใช้งาน (เดือน)",
        selector: (row) => row.Item_Age,
        minWidth: "150px"
      },
      {
        name: "วันที่เริ่มต้น",
        selector: (row) => row.Age_Start_Date,
        format: (row) => formatDate(row.Age_Start_Date),
        minWidth: "200px"
      },
      {
        name: "วันที่หมดอายุ",
        selector: (row) => row.Age_End_Date,
        format: (row) => formatDate(row.Age_End_Date),
        minWidth: "200px"
      },
      {
        name: "วันที่เช็คเปลี่ยน",
        selector: (row) => row.Age_Change_Date,
        format: (row) => formatDate(row.Age_Change_Date),
        minWidth: "200px"
      },
      {
        name: "วันที่เปลี่ยนครั้งต่อไประหว่างวันที่",
        selector: (row) => row.Age_Between_Date,
        format: (row) => formatDate(row.Age_Between_Date),
        minWidth: "200px"
      },
      {
        name: "ถึงวันที่",
        selector: (row) => row.Age_To_Date,
        format: (row) => formatDate(row.Age_To_Date),
        minWidth: "200px"
      },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            editButton
            state={{
              edit: { name: "determine", type: "sticker", row, searchValue }
            }}
          />
        ),
        width: "120px"
      }
    ]
  };

  const cardSearchDisplay = ({ header, data, input, search, Btn }) => {
    return (
      <CardDisplayComponent
        header={
          header ? { title: { className: "text-center", text: header } } : null
        }
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={input}
              searchCallback={search}
              searchBtnOnClick={Btn?.search}
              clearBtnOnClick={Btn?.clear}
              fieldClassName={{
                inputRow: "justify-content-end",
                actionButton: "w-auto"
              }}
            />
          )
        }}
      />
    );
  };

  const cardTableDisplay = ({ header, button, data, column, search }) => {
    return (
      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-center",
          title: header ? { text: header } : null,
          button
        }}
        body={{
          element: (
            <Table
              data={data}
              column={column}
              searchFilter={search}
              pending={loading}
            />
          )
        }}
      />
    );
  };

  const handleSearchItem = (search, type) => {
    const Contract_No = searchValue.Contract?.[0]?.value;
    setSearchValue((prev) => ({
      ...prev,
      [type]: search.some(({ value }) => value)
        ? [
            ...search.filter(({ value }) => value),
            { name: "CustContractItem.Contract_No", value: Contract_No }
          ].filter(Boolean)
        : []
    }));
    !search.some(({ value }) => value) &&
      navigate("/PM_work/bind", {
        state: { ...state, searchValue: { ...state?.searchValue, [type]: [] } }
      });
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DefineAgeEquipsService.getAllDefineAgeEquips(),
      callback: (res) => setData((prev) => ({ ...prev, Age: res }))
    });
  }, []);

  useEffect(() => {
    if (state?.name === "determine") {
      const updateValues = (key) =>
        defaultSearch?.[key].map((item) =>
          item.name === state?.searchValue?.[key]?.[0]?.name
            ? { ...item, value: state?.searchValue?.[key]?.[0]?.value }
            : item
        );

      setSearchInput((prev) => ({
        ...prev,
        Contract: updateValues("Contract"),
        Age: updateValues("Age"),
        Sticker: updateValues("Sticker")
      }));
    }
  }, [state?.searchValue]);

  return (
    <>
      {cardSearchDisplay({
        data: data.Contract,
        input: searchInput.Contract,
        Btn: {
          search: state?.searchValue?.Contract.length > 0,
          clear: state?.searchValue?.Contract.length === 0
        },
        search: (search) => {
          setSearchValue((prev) => ({
            ...prev,
            Contract: search.some(({ value }) => value)
              ? search.filter(({ value }) => value)
              : [],
            Age: [],
            Sticker: []
          }));
          !search.some(({ value }) => value) &&
            navigate("/PM_work/bind", {
              state: {
                ...state,
                searchValue: { Contract: [], Age: [], Sticker: [] }
              }
            });
        }
      })}

      {cardTableDisplay({
        header: "รายการสินค้าที่จะกำหนดอายุอุปกรณ์/อะไหล่",
        data: data.Contract,
        column: columns.Contract,
        search: searchValue.Contract,
        button: (
          <ButtonLink
            linkTo="create"
            stateData={{ name: "determine", type: "age", searchValue }}
            buttonName="เพิ่มข้อมูลอายุอุปกรณ์/อะไหล่"
            buttonClass="px-5 py-2 rounded-pill"
            iconSrc={AddIcon}
            iconName="Add Icon"
            iconClass="mb-1 me-2"
          />
        )
      })}

      {cardSearchDisplay({
        header: "ข้อมูลอายุอุปกรณ์/อะไหล่",
        data: filteredItemBySearch(
          data.Age,
          searchValue.Contract,
          "CustContractItem.Contract_No"
        ),
        input: searchInput.Age,
        Btn: {
          search: state?.searchValue?.Age.length > 0,
          clear: state?.searchValue?.Age.length < 2
        },
        search: (search) => handleSearchItem(search, "Age")
      })}

      {cardTableDisplay({
        data: data.Age,
        column: columns.Age,
        search: searchValue.Age
      })}

      {cardSearchDisplay({
        header: "ข้อมูล Sticker Date",
        data: filteredItemBySearch(
          data.Age,
          searchValue.Contract,
          "CustContractItem.Contract_No"
        ),
        input: searchInput.Sticker,
        Btn: {
          search: state?.searchValue?.Sticker.length > 0,
          clear: state?.searchValue?.Sticker.length < 2
        },
        search: (search) => handleSearchItem(search, "Sticker")
      })}

      {cardTableDisplay({
        header: "รายการอุปกรณ์/อะไหล่ที่กำหนด Sticker Date",
        data: data.Age,
        column: columns.Sticker,
        search: searchValue.Sticker,
        button: (
          <ButtonLink
            linkTo="create"
            stateData={{ name: "determine", type: "sticker", searchValue }}
            buttonName="เพิ่มข้อมูล Sticker Date"
            buttonClass="px-5 py-2 rounded-pill"
            iconSrc={AddIcon}
            iconName="Add Icon"
            iconClass="mb-1 me-2"
          />
        )
      })}
    </>
  );
}
